<div class="pg-content__inner-transparent">
  <div class="confirm-email__loading">
    <div class="ui-loader ui-loader__page-light"></div>
  </div>
</div>
